import { AxiosResponse } from 'axios'
import React, { useCallback, useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Loader from '../../../../components/loader'
import { APIResponseEntity } from '../../../../interface/api-responce'
import { APIToStoreTrustSealUserDetail } from '../../../../service/api-service'
import { IsStringNullEmptyOrUndefined } from '../../../../utils/null-check'
import '../../css/index.css'
import { VerifiedTrustSealRecordEntity } from '../../interface/trust-seal.interface'
import { toastTrustSealOptObj, TrustSealStorageKey } from '../../utils/constant'
import InvalidatedRecord from './InvalidatedRecord'
import TrustSealNotFound from './TrustSealNotFound'
import ValidatedRecord from './ValidatedRecord'
import WhatsAppOtpDialog from './WhatsAppOtpDialog'



const TrustSealPage = () => {

    const [showWhatsAppDialog, setShowWhatsAppDialog] = useState(false)

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [verifiedTrustSealDetail, setVerifiedTrustSealDetail] = useState<VerifiedTrustSealRecordEntity | null>(null);


    const { id } = useParams();

    const scrollToQuotation = useCallback((event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault()
        const element = document.getElementById('quotation')
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' })
        }
    }, []);

    const storeAndFetchInformation = async () => {
        setIsLoading(true);
        try {
            const resp: AxiosResponse<APIResponseEntity> =
                await APIToStoreTrustSealUserDetail(id ?? "");

            if (!resp || resp.status !== 200 || !resp.data) {
                return;
            }

            const apiResp: APIResponseEntity = resp.data;

            if (
                apiResp.status &&
                apiResp.statusCode === 200 &&
                apiResp.data
            ) {
                setVerifiedTrustSealDetail(apiResp.data);
                localStorage.setItem(TrustSealStorageKey, JSON.stringify(apiResp.data))
            } else {
                toast.error(apiResp.message || apiResp.errorMsg, {
                    ...toastTrustSealOptObj,
                });
            }
        } catch (error) {
            console.log(error, "error")
        }
        finally {
            setIsLoading(false);
        }
    }

    const handleOTPVerified = useCallback(() => {

        // Wait a few seconds before auth and page refresh
        const timer = setTimeout(() => {
            // Scroll to top
            // Close dialog immediately
            setShowWhatsAppDialog(false);
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });

        }, 2000); // 2 second delay

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {

        const alreadyProcessed = localStorage.getItem(TrustSealStorageKey);

        if (alreadyProcessed && !IsStringNullEmptyOrUndefined(alreadyProcessed)) {
            const record: VerifiedTrustSealRecordEntity = JSON.parse(alreadyProcessed);
            if (record.orderId === id) {
                setVerifiedTrustSealDetail(JSON.parse(alreadyProcessed));
                return
            }
        }

        if (id) {
            storeAndFetchInformation();
        }
    }, [id])

    return (
        <>
            <Loader isLoading={isLoading} />
            {
                !isLoading && (
                    <div id="validatedTrustSeal">
                        {/* Header */}
                        <section
                            style={{
                                backgroundImage: "url('/assets/images/trust-seal/banner-jbwaltz.jpg')",
                                height: '700px',
                            }}
                        >
                            <div className="container">
                                <div className="row mx-0">
                                    <div className="col-md-12 text-center">

                                        <div className="p-t-b-20">
                                            <img src="/assets/images/trust-seal/jb-logo.png" alt="" width="200" />
                                        </div>

                                        <div className="p-t-b-30">
                                            <img src="/assets/images/trust-seal/Seal@4x-8.png" alt="" width="330" />
                                        </div>

                                        <div className="p-b-30">
                                            <a href="#quotation" onClick={scrollToQuotation}><img className="arrow-img" src="/assets/images/trust-seal/Arrow@4x-8.png" alt="Scroll to quotation" width="50" /></a>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </section>
                        {
                            verifiedTrustSealDetail ? (
                                verifiedTrustSealDetail.quotationStatus === 'Invalid' ? (
                                    <InvalidatedRecord data={verifiedTrustSealDetail} />
                                ) : (
                                    <ValidatedRecord data={verifiedTrustSealDetail} onOpenWhatsAppDialog={() => setShowWhatsAppDialog(true)} />
                                )
                            ) : (
                                <TrustSealNotFound />
                            )
                        }

                        <WhatsAppOtpDialog
                            visible={showWhatsAppDialog}
                            onHide={() => setShowWhatsAppDialog(false)}
                            onVerified={handleOTPVerified}
                            trustSealId={verifiedTrustSealDetail ? verifiedTrustSealDetail.trustSealUserId : ""}
                        />
                    </div>
                )
            }
        </>
    )
}

export default TrustSealPage